function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

export function includeKeys(object, predicate) {
  var result = {};

  if (Array.isArray(predicate)) {
    var _iterator = _createForOfIteratorHelper(predicate),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var key = _step.value;
        var descriptor = Object.getOwnPropertyDescriptor(object, key);

        if (descriptor !== null && descriptor !== void 0 && descriptor.enumerable) {
          Object.defineProperty(result, key, descriptor);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } else {
    // `Reflect.ownKeys()` is required to retrieve symbol properties
    var _iterator2 = _createForOfIteratorHelper(Reflect.ownKeys(object)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _key = _step2.value;

        var _descriptor = Object.getOwnPropertyDescriptor(object, _key);

        if (_descriptor.enumerable) {
          var value = object[_key];

          if (predicate(_key, value, object)) {
            Object.defineProperty(result, _key, _descriptor);
          }
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return result;
}
export function excludeKeys(object, predicate) {
  if (Array.isArray(predicate)) {
    var set = new Set(predicate);
    return includeKeys(object, function (key) {
      return !set.has(key);
    });
  }

  return includeKeys(object, function (key, value, object) {
    return !predicate(key, value, object);
  });
}